var $88a3bf0d79ac60db$exports = {};
// A switch is the only button that is a field's control.
const $88a3bf0d79ac60db$var$SWITCH = 'button[role="switch"]';
// A select's trigger is a span, so `for` cannot reach it and aria-labelledby
// is the whole name.
const $88a3bf0d79ac60db$var$COMBOBOX = '[role="combobox"]';
const $88a3bf0d79ac60db$var$LABELABLE = `input:not([type="hidden"]), select, textarea, ${$88a3bf0d79ac60db$var$SWITCH}, ${$88a3bf0d79ac60db$var$COMBOBOX}`;
const $88a3bf0d79ac60db$var$ERRORS = '[data-form-error]';
const $88a3bf0d79ac60db$var$HELP = '.form-group__help';
const $88a3bf0d79ac60db$var$LABEL = '[data-field-label]';
const $88a3bf0d79ac60db$var$LABEL_TEXT = '[data-field-label-text]';
const $88a3bf0d79ac60db$var$REQUIRED = 'data-field-required';
const $88a3bf0d79ac60db$var$REQUIRED_MARKER = '[data-field-required-marker]';
const $88a3bf0d79ac60db$var$INSIDE_A_MENU = '[role="listbox"], [role="menu"]';
const $88a3bf0d79ac60db$var$TRIGGER = '[aria-haspopup="listbox"]';
const $88a3bf0d79ac60db$var$NAMED = 'data-field-named';
let $88a3bf0d79ac60db$var$fieldIds = 0;
const $88a3bf0d79ac60db$var$MANAGED_DESCRIPTION = /^elm-field-\d+-description-\d+$/;
const $88a3bf0d79ac60db$var$MANAGED_LABEL = /^elm-field-\d+-label$/;
function $88a3bf0d79ac60db$var$describe(control, descriptionIds) {
    const ids = [
        ...new Set((control.getAttribute('aria-describedby') ?? '').split(' ').filter((id)=>id && !$88a3bf0d79ac60db$var$MANAGED_DESCRIPTION.test(id)).concat(descriptionIds))
    ];
    if (ids.length === 0) control.removeAttribute('aria-describedby');
    else control.setAttribute('aria-describedby', ids.join(' '));
}
function $88a3bf0d79ac60db$var$unname(control) {
    const name = control.getAttribute('aria-labelledby') ?? '';
    if (control.hasAttribute($88a3bf0d79ac60db$var$NAMED) || $88a3bf0d79ac60db$var$MANAGED_LABEL.test(name)) {
        control.removeAttribute('aria-labelledby');
        control.removeAttribute($88a3bf0d79ac60db$var$NAMED);
    }
}
class $88a3bf0d79ac60db$var$ElmField extends HTMLElement {
    connectedCallback() {
        this.fieldId ??= `elm-field-${++$88a3bf0d79ac60db$var$fieldIds}`;
        this.wire();
        this.observer = new MutationObserver(()=>this.wire());
        this.observer.observe(this, {
            childList: true,
            subtree: true
        });
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    own(selector) {
        return [
            ...this.querySelectorAll(selector)
        ].filter((el)=>el.closest('elm-field') === this);
    }
    describedBy(node, controls) {
        for(let el = node.parentElement; el; el = el.parentElement){
            const within = controls.filter((control)=>el.contains(control));
            if (within.length === 1) return within;
            if (within.length > 1) return controls;
            if (el === this) break;
        }
        return controls;
    }
    wire() {
        const labelable = this.own($88a3bf0d79ac60db$var$LABELABLE).filter((el)=>!el.closest($88a3bf0d79ac60db$var$INSIDE_A_MENU));
        const triggers = this.own($88a3bf0d79ac60db$var$TRIGGER);
        const trigger = labelable.length === 0 && triggers.length === 1 ? triggers[0] : null;
        const controls = trigger ? [
            trigger
        ] : labelable;
        const described = new Map(controls.map((control)=>[
                control,
                []
            ]));
        this.own(`${$88a3bf0d79ac60db$var$ERRORS}, ${$88a3bf0d79ac60db$var$HELP}`).forEach((node, index)=>{
            if (!node.id || $88a3bf0d79ac60db$var$MANAGED_DESCRIPTION.test(node.id)) node.id = `${this.fieldId}-description-${index}`;
            this.describedBy(node, controls).forEach((control)=>described.get(control).push(node.id));
        });
        controls.forEach((control)=>$88a3bf0d79ac60db$var$describe(control, described.get(control)));
        // On a group, aria-required would mark its optional parts required too.
        const marker = this.own($88a3bf0d79ac60db$var$REQUIRED_MARKER)[0];
        const onControl = this.hasAttribute($88a3bf0d79ac60db$var$REQUIRED) && labelable.length === 1;
        labelable.forEach((control)=>control.removeAttribute('aria-required'));
        if (onControl) {
            labelable[0].setAttribute('aria-required', 'true');
            marker?.setAttribute('aria-hidden', 'true');
        } else marker?.removeAttribute('aria-hidden');
        const [label] = this.own($88a3bf0d79ac60db$var$LABEL);
        if (!label) {
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            [
                ...labelable,
                ...triggers
            ].forEach($88a3bf0d79ac60db$var$unname);
            return;
        }
        const [labelText] = this.own($88a3bf0d79ac60db$var$LABEL_TEXT);
        const nameSource = labelText ?? label;
        nameSource.id ||= `${this.fieldId}-label`;
        const names = [
            nameSource
        ];
        if (marker && !onControl) {
            marker.id ||= `${this.fieldId}-required`;
            names.push(marker);
        }
        if (trigger) {
            label.removeAttribute('for');
            trigger.id ||= `${this.fieldId}-control`;
            const ids = [
                ...names,
                trigger
            ].map((node)=>node.id);
            trigger.setAttribute('aria-labelledby', ids.join(' '));
            trigger.setAttribute($88a3bf0d79ac60db$var$NAMED, '');
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            return;
        }
        triggers.forEach($88a3bf0d79ac60db$var$unname);
        triggers.filter((t)=>!controls.includes(t)).forEach((t)=>$88a3bf0d79ac60db$var$describe(t, []));
        const [control] = controls;
        if (controls.length === 1 && !control.closest('label')) {
            control.id ||= `${this.fieldId}-control`;
            label.htmlFor = control.id;
            this.removeAttribute('role');
            this.removeAttribute('aria-labelledby');
            // A switch's own name carries why it is disabled.
            if (labelText && !control.matches($88a3bf0d79ac60db$var$SWITCH)) control.setAttribute('aria-labelledby', labelText.id);
            else $88a3bf0d79ac60db$var$unname(control);
        } else {
            label.removeAttribute('for');
            this.setAttribute('role', 'group');
            this.setAttribute('aria-labelledby', names.map((node)=>node.id).join(' '));
            controls.forEach($88a3bf0d79ac60db$var$unname);
        }
    }
}
if (!customElements.get('elm-field')) customElements.define('elm-field', $88a3bf0d79ac60db$var$ElmField);


//# sourceMappingURL=provider-portal.4be6cb64.js.map
